import { defineStore } from 'pinia'

import type { ScheduleStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useScheduleStore = defineStore('schedule', {
  state: (): ScheduleStore => ({
    loading: false,
    modalSchedule: false,
    modalScheduleSuccess: false,
    modalConfirmWeeklySchedule: false,
    availableSlots: [],
    selectedDate: null,
    selectedTime: null,
    timeMode: 'normal',
    availabilityMath: null,
    availabilityEla: null,
    weeklySchedule: [],
    selectedDays: [],
    showErrors: false,
  }),
  actions,
  getters,
})
